import { EntityType } from '@frontend/common';
import { defaultCellClassName } from '@frontend/components/list';
import { ReactiveObjectList } from '@frontend/components/list-v2';
import { BooleanBadge } from '@frontend/elements';
import { CommonMessage } from '@frontend/lang';
import { SettingClient } from '@frontend/setting/api';
import { Setting } from '@frontend/setting/types';

import { PlatformObjectBadgeMapper } from '../../modal/platform-object-badge/platform-object-badge-mapper.component';
import { useSettingsList } from './settings-list.controller';

export interface SettingsListProps {
    entity_id: string;
    entity_type: EntityType;
}

export const SettingsList = (props: SettingsListProps) => {
    const viewProps = useSettingsList();
    return (
        <ReactiveObjectList<Setting>
            label={CommonMessage.OBJECTS.SETTING.PLURAL}
            fetch={(arg) => SettingClient.fetchSettings({ ...arg, entity_id: props.entity_id, entity_type: props.entity_type })}
            dispatch={viewProps.dispatch}
            columns={{
                columns: ['key', 'value', 'auto_generated'],
                customCells: new Map([
                    [
                        'key',
                        (obj) => {
                            return <td className={defaultCellClassName}>{obj.row.original.key.replace(/_/g, ' ')}</td>;
                        }
                    ],
                    [
                        'value',
                        (obj) => {
                            const { key, value } = obj.row.original;
                            if (typeof obj.row.original.value === 'boolean') {
                                return (
                                    <td className='text-brand-primary align-content-center text-truncate text-xs'>
                                        <BooleanBadge value={obj.row.original.value} />
                                    </td>
                                );
                            }
                            if (!value)
                                return (
                                    <td>
                                        <span className='text-brand-muted'>-</span>
                                    </td>
                                );
                            if (!key.endsWith('_id') && !key.endsWith('_ids')) {
                                return (
                                    <td className='text-brand-primary align-content-center text-truncate text-xs'>
                                        <span>{value}</span>
                                    </td>
                                );
                            }

                            if (key.endsWith('_ids')) {
                                const values = Array.isArray(value) ? value : [value];
                                return (
                                    <td className={`${defaultCellClassName} flex flex-wrap items-center gap-1`}>
                                        {values.map((entry) => (
                                            <PlatformObjectBadgeMapper
                                                key={`${key}-${entry}`}
                                                id={entry as string}
                                                type={key.slice(0, -1)}
                                            />
                                        ))}
                                    </td>
                                );
                            }

                            return (
                                <td className={defaultCellClassName}>
                                    <PlatformObjectBadgeMapper
                                        id={value as string}
                                        type={key}
                                    />
                                </td>
                            );
                        }
                    ]
                ])
            }}
            type={EntityType.SETTING}
            tableProps={{ defaultHeight: true, hideFooter: true }}
        />
    );
};
